//Limitless imports
import { handleSecureAjaxError } from "../utils/SecurePlatformAPIUtils";
import { getGraphQLClient } from "../clients/GraphQLClient";
import { PASS_MESSAGE, UNPASS_MESSAGE } from "./queries/MessageUserPassMutations";
const PASSED_MAPPER = {
  pass: {
    mutation: PASS_MESSAGE,
    returnTypeName: "passMessage"
  },
  unpass: {
    mutation: UNPASS_MESSAGE,
    returnTypeName: "unpassMessage"
  }
};
export const passExpertMessage = (message, passed, callback) => {
  const graphQLClient = getGraphQLClient();
  const action = PASSED_MAPPER[passed ? "pass" : "unpass"];
  graphQLClient.mutate({
    mutation: action.mutation,
    variables: {
      messageId: message.messageId
    }
  }).then(response => {
    const message = response.data[action.returnTypeName];
    callback(message);
  }).catch(error => {
    handleSecureAjaxError(error, "MessageUserPassActions passExpertMessage");
    callback({
      hasError: true,
      error
    });
  });
};